// The tabs of the report of a send (plan §9.1, ADR-315 §6), in the address so a link opens the one it names: small, the
// router reads it before the page is loaded.

export const sendReportTabs = ["overview", "map", "links", "buyers", "arrivals", "documents"] as const;
export type SendReportTab = (typeof sendReportTabs)[number];
